import { CLIENT_BRANCH_ORDER_SETTING_API } from "shared/constants/api-endpoint";
import { apiClient } from "shared/plugins/http-service";
import { IBranchOrderPickupSettingModel } from "./order-pickup-setting.models";
export const getBranchOrderPickupSettingAPI = async (branchId: number) => {
  return await apiClient.getHttp<IBranchOrderPickupSettingModel>(
    `${CLIENT_BRANCH_ORDER_SETTING_API}`,
    {
      params:{
        branchId: branchId,
      }
    },
    false
  );
};
